import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useResendVerificationCode } from "../api/resend-verification-code";
import { useUserState } from "../store/use-user-state";
import { useVouchersDistributionState } from "../store/use-vouchers-distribution-state";
import type { ConfigName } from "../types/config-name";

type UseResendCodeOptions = {
  onSuccess?: () => void;
  configName: ConfigName;
};

export const useResendCode = ({ onSuccess, configName }: UseResendCodeOptions) => {
  const { voucherDistribution } = useVouchersDistributionState();
  const { user, setUser } = useUserState();
  const { t } = useTranslation();

  const {
    mutate: resendVerificationCode,
    isLoading,
    isSuccess,
    isError,
  } = useResendVerificationCode({
    config: {
      onSuccess: (data) => {
        setUser({ ...user, isValid: true, error: undefined, token: data.token });
        onSuccess?.();
      },
    },
  });

  const handleSubmit = () => {
    if (!voucherDistribution?.slug || !user?.token) {
      toast.error(t("VOUCHERS_DISTRIBUTION.ERRORS.GENERAL_ERROR"));
      return;
    }
    resendVerificationCode({
      slug: voucherDistribution.slug,
      token: user.token,
      configName,
    });
  };

  return {
    handleSubmit,
    isLoading,
    isSuccess,
    isError,
  };
};
